<template lang="pug">
  .coach-detail-profile
    h4.profile PROFILE
    multiline-text-view(
      v-if="coach.profile"
      :text="coach.profile"
      class="multiline-text-view"
      :style="styleMultilineText"
    )
    f7-link(
      href="#"
      class="show-more-link"
      @click="onClick")
      | {{ linkTitle }}
</template>

<style lang="scss" scoped>
.coach-detail-profile {
  h4 {
    padding: 0;
    margin: 0;
    text-align: center;
    @extend %title;
    opacity: 0.8;
    font-size: 16px;
    letter-spacing: 4px;
    line-height: 28px;
  }

  .multiline-text-view {
    margin: 16px 0;
    padding: 0;
  }
  .show-more-link {
    display: block;
    text-align: center;
    margin-top: auto;
    margin-bottom: 16px;
    color: $color-primary;
  }
}
</style>

<script>
import MultilineTextView from '@/components/molecules/MultilineTextView'

export default {
  components: {
    MultilineTextView,
  },
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isShowMore: false,
    }
  },
  computed: {
    styleMultilineText() {
      if (this.isShowMore) {
        return {}
      }
      return {
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': 9,
      }
    },
    linkTitle() {
      if (this.isShowMore) {
        return '▲ とじる'
      }
      return '▼ つづきを読む'
    },
  },
  methods: {
    onClick() {
      this.isShowMore = !this.isShowMore
    },
  },
}
</script>
